import React from "react";
import { Image } from "react-konva";
import { ImageShape as IImageShape } from "../../../../types"; // Use ImageShape, not SVGShape
import { mergeRefs } from "../../../../utils/mergeRef";
import { getWindowKonvaObject } from "../../helpers/konva/getWindowKonvaObject";
import { ShapeCommonProps } from "../../types";
import { useShape } from "../ShapeContext/useShape";

export const ImageShape = React.forwardRef<
  React.ComponentRef<typeof Image>,
  ShapeCommonProps
>((commonProps, ref) => {
  const { shape, image, setImage } = useShape();

  const imageShape = shape as IImageShape;
  const shapeRef = React.useRef<React.ComponentRef<typeof Image>>(null);

  React.useEffect(() => {
    (async () => {
      if (shape.type === "image") {
        const img = new window.Image();
        img.src = imageShape.path;
        img.crossOrigin = "Anonymous";
        img.onload = () => {
          setImage(img);
          getWindowKonvaObject().stages?.[0]?.fire?.("contentChange");
        };
      }
    })().then();
  }, [shape.type, imageShape.path]);

  React.useEffect(() => {
    if (shape.type === "image" && image) {
      const layer = shapeRef.current?.getLayer();
      if (layer) {
        layer.batchDraw();
      }
    }
  }, [shape.type, image]);

  return (
    <Image
      {...commonProps}
      image={image || undefined}
      width={shape.width}
      height={shape.height}
      scaleX={1}
      scaleY={1}
      opacity={shape.locked ? 0.5 : 1}
      imageSmoothingEnabled={true}
      perfectDrawEnabled={true}
      ref={mergeRefs([shapeRef, ref])}
    />
  );
});
